import styled from "styled-components";

export const Content = styled.div`
  align-items: center;
  background-color: #fff;
  background-size: contain;
  border-radius: 13px;
  display: flex;
  font-size: 20px;
  height: 125px;
  justify-content: center;
  max-width: 90%;
  padding: 10px 20px 15px;
  width: 100%;
`;